import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ourstaff',
  templateUrl: './ourstaff.component.html',
  styleUrls: ['./ourstaff.component.css']
})
export class OurstaffComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
